import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { Stack, Box, Typography, IconButton, Tooltip } from '@mui/material'
import { ArrowBack as ArrowBackIcon, Close as CloseIcon, Lock as LockIcon } from '@mui/icons-material'
import { hideFormModal } from 'state/ui'
import { generateLockTooltip } from 'utils/helpers'

const FormModalHeading = ({
  title,
  subtitle,
  backButtonPosition,
  onBack,
  statusChip,
  isInLockedAccountingPeriodV2,
  type,
}) => {
  const dispatch = useDispatch()

  const handleBackClick = () => {
    if (onBack) {
      onBack()
    } else {
      dispatch(hideFormModal())
    }
  }

  return (
    <Stack alignItems="center" py={3} px={2}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }} width="100%">
        {backButtonPosition === 'left' && (
          <IconButton onClick={handleBackClick}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <Stack direction="row" alignItems="center" spacing={1} px={2}>
          {isInLockedAccountingPeriodV2 && (
            <Tooltip title={generateLockTooltip(type)} placement="top">
              <LockIcon color="info" />
            </Tooltip>
          )}
          <Typography variant="h5" pr={statusChip ? 1 : 0}>
            {title}
          </Typography>
          {statusChip}
        </Stack>
        {backButtonPosition === 'right' ? (
          <IconButton onClick={handleBackClick}>
            <CloseIcon />
          </IconButton>
        ) : (
          <div />
        )}
      </Box>
      {subtitle && <Typography mt={1}>{subtitle}</Typography>}
    </Stack>
  )
}

FormModalHeading.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  backButtonPosition: PropTypes.string,
  onBack: PropTypes.func,
  statusChip: PropTypes.node,
  isInLockedAccountingPeriodV2: PropTypes.bool,
  type: PropTypes.string,
}

FormModalHeading.defaultProps = {
  title: 'Submit',
  subtitle: null,
  backButtonPosition: 'left',
  onBack: null,
  statusChip: null,
  isInLockedAccountingPeriodV2: false,
  type: null,
}

export default FormModalHeading
